import { apiFetcher } from "./apiFetcher";
import _ from "lodash";

export const productsService = {
  getProducts,
  getProductById,
};

function getProducts(storeId, query, accessToken) {
  const baseUrl = `product`
 
  const pagingArray = [];
  pagingArray.push(`page=${query.filters.page}`);
  pagingArray.push(`limit=${query.filters.per_page}`);

  const sortArray = query.filters.sort_by ? sortAdapter(query.filters.sort_by) : []

  const url = queryStringsAdapter(baseUrl, pagingArray.concat(sortArray));

  return apiFetcher(
    storeId,
    accessToken,
    url,
    { method: "GET" },
    1,
    true
  );
}

function getProductById(storeId, productId, accessToken) {
  const url = `product/${productId}`
  
  return apiFetcher(storeId, accessToken, url, {
    method: "GET"
  })
}

export default function queryStringsAdapter(url, paramsStringsArray) {
  if (url) {
    let newUrl = url;

    for (const paramString of paramsStringsArray) {
      if (paramString) {
        if (newUrl.includes("?")) {
          newUrl = newUrl + `&${paramString}`;
        } else {
          newUrl = newUrl + `?${paramString}`;
        }
      }
    }

    return newUrl;
  } else {
    return url;
  }
}

const replacements = [{ field: "release", replace: "date_added" }];

function sortAdapter(sort) {
  const array = [];

  const split = sort.split("-");

  if (split.length === 2) {
    let sortField = split[0];

    const replacement = replacements.find((x) => x.field === sortField);

    if (replacement) {
      sortField = replacement.replace;
    }

    array.push(`sort=${sortField}`);
    array.push(`order=${split[1]}`);
  }

  return array;
}
